import React, {useCallback, useState} from "react";
import { TextBox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { eyeIcon, eyeSlashIcon } from '@progress/kendo-svg-icons';
import {useField, useFormikContext} from "formik";
import { FieldError } from "../Error/FieldError.jsx";

export const PasswordInput = ({ label, required, style, disabled = false, onChange, ...otherProps }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [field, meta] = useField(otherProps);
    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;

    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
        }
    };

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };

    const ToggleButton = useCallback(() => (
        <Button svgIcon={showPassword ? eyeSlashIcon : eyeIcon} onClick={togglePassword} fillMode="flat" />
    ), [showPassword]);

    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <TextBox
                type={showPassword ? 'text' : 'password'}
                suffix={ToggleButton}
                {...field}
                {...otherProps}
                disabled={isDisabled}
                onChange={handleChange}
            />
            <FieldError name={otherProps.name}/>
        </>
    );
};